// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PageName_wrapper__1L46e","pageName":"PageName_pageName__gabjV","pageNameText":"PageName_pageNameText__LmWSX","removeActivePage":"PageName_removeActivePage__3O45x"};